import { AutocompleteOption } from 'redesign';
import {
  getBranchOffices,
  getDepartments,
  getJobTypes,
} from 'hq/components/views/planner/shifts/filters/utils/utils';
import { PlanningFilters, ShiftPlanningFiltersFormType } from './planning-filter.types';
import { PlanningFilterData } from './filters';

const getShiftPlanningFiltersDefaultValues = (
  appliedFilters: PlanningFilters,
  filterData: PlanningFilterData
): ShiftPlanningFiltersFormType => {
  const result: ShiftPlanningFiltersFormType = {
    company: null,
    branchOffices: null,
    departments: null,
    jobType: null,
    isFreelance: appliedFilters.isFreelance ?? false,
    isTempWork: appliedFilters.isTempWork ?? false,
    isEmployee: appliedFilters.isEmployee ?? false,
    filledStatusCheckboxValue: !!appliedFilters.filledStatus,
    allowApplicantsFilter: appliedFilters.hasApplicants != null ? true : false,
    jobTypeCheckboxValue: !!appliedFilters.jobType?.length,
    filledStatus: appliedFilters.filledStatus ? appliedFilters.filledStatus : 'inProgress',
    hasApplicants: appliedFilters.hasApplicants != null ? appliedFilters.hasApplicants : true,
    businessUnitCheckboxValue: !!appliedFilters.company || !!appliedFilters.branchOfficeIds?.length,
    employmentTypeCheckboxValue:
      !!appliedFilters.isFreelance || !!appliedFilters.isTempWork || !!appliedFilters.isEmployee,
  };

  if (appliedFilters.jobType?.length) {
    const jobTypes = getJobTypes(appliedFilters.jobType, filterData.jobTypes);
    if (jobTypes?.length) {
      result.jobType = jobTypes.map((jt) => ({ id: jt.value, name: jt.label }));
    }
  }

  const companies = filterData.businessUnits.companies ?? [];
  const allBranchOffices =
    companies.length > 0
      ? companies.flatMap((company) => company.branchOffices ?? [])
      : (filterData.businessUnits.branchOffices ?? []);

  if (appliedFilters.branchOfficeIds?.length) {
    result.branchOffices = getBranchOffices(appliedFilters.branchOfficeIds, allBranchOffices);
  }

  if (appliedFilters.departmentIds?.length) {
    result.departments = getDepartments(appliedFilters.departmentIds, allBranchOffices);
  }

  if (!appliedFilters.company) {
    return result;
  }

  const companyFilter = companies.find((company) => company.companyId === appliedFilters.company);

  if (!companyFilter) {
    return result;
  }

  const company: AutocompleteOption = {
    value: companyFilter.companyId,
    label: companyFilter.companyName,
  };
  result.company = company;

  return result;
};

export { getShiftPlanningFiltersDefaultValues };
